import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../tooltip';
import Button from '../button';
import classNames from 'classnames';

const actionStyles = {
  delete: {
    icon: 'trash-alt',
  },
  edit: {
    icon: 'pencil-alt',
  },
};

export default function TableActionButton(props) {
  const {action, label, icon, className, disabled, ...rest} = props;
  const buttonProps = actionStyles[action] || {};
  buttonProps.disabled = disabled;

  if (icon) {
    buttonProps.icon = icon;
  }

  return disabled ? (
    <Button className={classNames('table-action-button', className)} {...buttonProps} {...rest} />
  ) : (
    <Tooltip message={label || `action.${action}`} placement="left" delay={500}>
      <Button className={classNames('table-action-button', className)} {...buttonProps} {...rest} />
    </Tooltip>
  );
}

TableActionButton.propTypes = {
  /** action to perform on this resource */
  action: PropTypes.string,
  /** the FontAwesome icon to use (without leading `fa-`). If not specified, the default will be used for the given `action`. */
  icon: PropTypes.string,
  /** I18n key to use as the action tooltip for this button. By default, `"action.{action}"` will be used." */
  label: PropTypes.string,
  /** An optional class name to add to the button. */
  className: PropTypes.string,
  /** Whether or not the button is disabled. */
  disabled: PropTypes.bool,
};
